import I18n from "i18n-js";
import React from "react"
// import DisabledLineItem from "./DisabledLineItem"


class FormTypeDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    // console.log(this.props.row)
    if (this.props.row.form_type == "order") {
      return (
        <div>{I18n.t("customer")}</div>
      );
    } else if (this.props.row.form_type == "document") {
      return (
        <div>{I18n.t("agreement")}</div>
      );
    } else if (this.props.row.form_type == "survey") {
      return (
        <div>{I18n.t("survey")}</div>
      );
    } else {
      return (
        <div>
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
  }

};

export default FormTypeDataType